import { ApiError, WorkSessionResponse, WorkSession, LateSession, LateSessionResponse } from "@/types/workSessions.type";
import { getCompanyId } from "./config.services";
import { api } from "./api";
import axios from "axios";

export const getSessionsByDate = async (date?: string) => {
  try {
    const companyId = getCompanyId();

    if (!companyId) {
      throw new Error("Entreprise non configurée");
    }

    const response = await api.post<WorkSessionResponse>(
      "/work-sessions/today",
      { companyId, date: date || undefined }
    );

    return response.data.workSessions;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const apiError = error.response.data as ApiError | undefined;
      throw new Error(
        apiError?.message || "Erreur lors de la récupération des sessions"
      );
    }
    throw new Error("Erreur lors de la récupération des sessions");
  }
};

/**
 * Retourne les sessions ouvertes dont l'heure de fin prévue au planning
 * est déjà dépassée. Le companyId vient du token (pas de body nécessaire).
 */
export const getLateSessions = async (): Promise<LateSession[]> => {
  try {
    const response = await api.post<LateSessionResponse>("/work-sessions/late");
    return response.data.workSessions;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const apiError = error.response.data as ApiError | undefined;
      throw new Error(
        apiError?.message || "Erreur lors de la récupération des sessions en retard"
      );
    }
    throw new Error("Erreur lors de la récupération des sessions en retard");
  }
};

/**
 * Met à jour une session de travail (notamment le commentaire)
 */
export const updateSession = async (
  sessionId: string,
  comment: string | null
): Promise<WorkSession> => {
  try {
    const response = await api.patch<{ message: string; workSession: WorkSession }>(
      `/work-sessions/pointeuse/${sessionId}/comment`,
      { comment }
    );

    return response.data.workSession;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const apiError = error.response.data as ApiError | undefined;
      throw new Error(
        apiError?.message || "Erreur lors de la mise à jour de la session"
      );
    }
    throw new Error("Erreur lors de la mise à jour de la session");
  }
};
